<div class="row">
  <div
    (click)="picture.isActive = !picture.isActive"
    *ngFor="let picture of pictures"
    [ngClass]="{ active: picture.isActive }"
    class="col-12 col-lg-6 col-xl-4 picture mt-4"
  >
    <div
      [ngStyle]="{ 'background-image': 'url(' + picture.imageUrl + ')' }"
      class="pic"
    ></div>
    <div class="text w-100 h-100 position-relative">
      <div [innerHTML]="picture.title" class="title anim m-0 p-2"></div>
      <div
        [innerHTML]="picture.description"
        class="desc anim m-0 p-2 text-center"
      ></div>
    </div>
  </div>
</div>
